import { useState, useEffect, useCallback } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { debounce } from "lodash";

export default function SearchBar({ produits, setProduitsFiltrés }) {
  const [searchTerm, setSearchTerm] = useState("");

  // Fonction debounce
  const debouncedSearch = useCallback(
    debounce((value) => {
      if (!value) {
        setProduitsFiltrés(produits);
      } else {
        const filtered = produits.filter((prod) =>
          Object.values(prod).some(
            (val) =>
              val &&
              val.toString().toLowerCase().includes(value.toLowerCase())
          )
        );
        setProduitsFiltrés(filtered);
      }
    }, 200),
    [produits, setProduitsFiltrés]
  );

  useEffect(() => {
    debouncedSearch(searchTerm);
    return () => debouncedSearch.cancel();
  }, [searchTerm, debouncedSearch]);

  return (
    <div className="w-full relative">
      <div className="flex items-center bg-gray-100 border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400 mr-2" />
        <input
          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full bg-transparent focus:outline-none text-sm text-gray-700 placeholder-gray-400"
        />
      </div>
    </div>
  );
}
